module.exports = __webpack_public_path__ + "static/media/ptc.logo.240w.1b451809.png";